import { Link } from 'react-router-dom';

function ServiceCard({ service }) {
  return (
    <article className="card service-card">
      <div
        className="service-card__image"
        style={{ '--service-image': `url(${process.env.PUBLIC_URL}${service.image})` }}
        aria-label={`${service.title} image`}
      />
      <div className="service-card__body">
        <img className="service-card__icon" src={`${process.env.PUBLIC_URL}${service.icon}`} alt="" aria-hidden="true" />
        <h3>{service.title}</h3>
        <p>{service.summary}</p>
        <Link to={service.path}>Learn more</Link>
      </div>
    </article>
  );
}

export default ServiceCard;
